<template>
  <div class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Instruments" active>
        <h3>Instruments</h3>
        <instrument-server-table :show_columns="['name', 'description']" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InstrumentServerTable from "@/components/lab/instrument/InstrumentServerTable";

export default {
  name: "AnalysisDetailCardstack",
  components: {
    InstrumentServerTable
  }
};
</script>
